import { createSelector } from 'reselect'
import { Firebase, Auth } from '../../Core'

export const getBattles = (state) => state.mars.battles

export const getBattleLoading = createSelector([getBattles], (battle) => battle.loading)
export const getCurrentBattleQuestion = createSelector(
  [getBattles],
  (battlesState) => battlesState.question
)
export const getCurrentBattle = createSelector(
  [getBattles],
  (battlesState) => battlesState.currentBattle
)
export const getBattleResume = createSelector(
  [getBattles],
  (battlesState) => battlesState.battleResume
)
export const getBattleUserResults = createSelector(
  [getCurrentBattle, Auth.selectors.getUserInfo],
  (battle, user) => {
    if (!battle.results || !battle.results[user.licenseId]) {
      return {}
    }
    return battle.results[user.licenseId]
  }
)
export const getBattleInfo = createSelector(
  [getCurrentBattle, getBattleUserResults],
  (battle, userResults) => {
    let info = {
      hits: 0,
      fails: 0,
      question: 1,
    }
    battle.questions &&
      battle.questions.map((q) => {
        if (userResults[q]) {
          info.question += 1
          userResults[q].right ? (info.hits += 1) : (info.fails += 1)
        }
      })
    return info
  }
)
export const getBattleInfoFromState = createSelector(
  [getBattles],
  (battlesState) => battlesState.info
)
export const getUserBattles = createSelector(
  [getBattles],
  (battlesState) => battlesState.userBattles
)
export const getAllUserBattles = createSelector(
  [getBattles],
  (battlesState) => battlesState.allUserBattles
)
export const getBattleResults = createSelector([getBattles], (battlesState) => {
  const results = Object.keys(battlesState.results).map((q) => battlesState.results[q])
  return results
})
export const getIndividualBattle = createSelector([getBattles], (battlesState) => {
  return battlesState.individualBattle
})
export const getRivalInfo = createSelector(
  [
    getCurrentBattle,
    getIndividualBattle,
    Firebase.selectors.getPlayerList,
    Auth.selectors.getUserInfo,
  ],
  (battle, individualBattle, playersList, user) => {
    let usingBattle = individualBattle ? individualBattle : battle
    if (!usingBattle || !usingBattle.players) {
      return null
    }
    const rivalId = usingBattle.players.find((player) => player != user.licenseId)
    return playersList[rivalId]
  }
)
